import React, { useState } from "react";
import "@/App.css";
import { AuthProvider, useAuth, CapabilityProvider, VoiceProvider } from "@/contexts";
import { LoginPage, DashboardPage, SettingsPage } from "@/pages";
import { VoiceWorkspace, RecordingWizard } from "@/components";
import { Toaster } from "@/components/ui/sonner";

const VOICE_CAPABILITY_ID = "voice-modeling-v1";

const AppContent = () => {
  const { user, loading } = useAuth();
  const [currentView, setCurrentView] = useState('dashboard');
  const [activeInstance, setActiveInstance] = useState(null);
  const [wizardData, setWizardData] = useState(null);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0a0a0b] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-zinc-700 border-t-zinc-400 rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) return <LoginPage />;

  if (currentView === 'wizard') {
    return (
      <RecordingWizard
        onComplete={(data) => {
          setWizardData(data);
          setCurrentView('workspace');
        }}
        onBack={() => {
          setCurrentView('dashboard');
          setActiveInstance(null);
        }}
      />
    );
  }

  if (currentView === 'workspace' && activeInstance?.capability_id === VOICE_CAPABILITY_ID) {
    return (
      <VoiceWorkspace 
        instance={activeInstance}
        wizardData={wizardData}
        onBack={() => {
          setActiveInstance(null);
          setWizardData(null);
          setCurrentView('dashboard');
        }} 
      />
    );
  }

  if (currentView === 'settings') {
    return <SettingsPage onBack={() => setCurrentView('dashboard')} />;
  }

  return (
    <DashboardPage 
      onOpenCapability={(instance) => {
        setActiveInstance(instance);
        setCurrentView('wizard');
      }}
      onOpenSettings={() => setCurrentView('settings')}
    />
  );
};

function App() {
  return (
    <div className="App dark">
      <AuthProvider>
        <CapabilityProvider>
          <VoiceProvider>
            <AppContent />
            <Toaster />
          </VoiceProvider>
        </CapabilityProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
